import { LinkButton } from '@euler/app/components/LinkButton';
import { HStack } from '@euler/components/layout/Stack';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { InspectionTaskStatus } from '@euler/model/enum';
import { memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

export const OrderSummaryHeaderRightView = memo(
  ({
    status,
    style,
    onShowDetail,
    onEditPress,
  }: {
    status: InspectionTaskStatus;
    onShowDetail?: () => void;
    onEditPress?: () => void;
    style?: StyleProp<ViewStyle>;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <HStack justifyContent="flex-end" style={style}>
        {onShowDetail ? (
          <LinkButton
            onPress={onShowDetail}
            text="订单详情"
            textStyle={{ fontSize: rpx(13) }}
          />
        ) : null}
        {status === InspectionTaskStatus.Finished ||
        status === InspectionTaskStatus.Cancelled ? undefined : (
          <LinkButton
            onPress={onEditPress}
            text="修改信息"
            ml={rpx(8)}
            textStyle={{ fontSize: rpx(13) }}
          />
        )}
      </HStack>
    );
  },
);
